import axios from 'axios' // 引入axios
import Cookie from 'js-cookie'
import tools from '~/tools/tools'
import signMd5Utils from "./signMd5Utils"
import {
  baseUrl
} from './env.js'

const instance = axios.create({
  baseURL: baseUrl, // api的base_url
  timeout: 20000,// 请求超时时间
})

// 请求
instance.interceptors.request.use(async (config) => {
  try {
    let Token = $app.$store.state.user.token || Cookie.get('TOKEN');
    config.headers['x-auth-token'] = Token || ''
  } catch (e) {
    // console.warn('本次请求没得TOKEN')
  }
  const uuid = Vue.prototype.$tools.guid()
  const sign = signMd5Utils.getSign(uuid)
  config.headers["x-auth-uu"] = uuid
  //请求id(用于后端调试)
  const requertIdUuid = Vue.prototype.$tools.guid()
  config.headers['X-Request-Id'] = requertIdUuid
  config.headers["x-auth-sign"] = sign

  return config

}, (error) => {
  return Promise.reject(error)
})

// 返回
instance.interceptors.response.use(async (res) => {

  // console.info(res)
  let token = res.headers['x-auth-token']
  if (token && res.data.code == '12200') {
    $app.$store.commit('user/setToken', token);
    Cookie.set('TOKEN', token);
  }
  const getMsg = () => `${res.data.msg}${res.data.requestId ? '[' + res.data.requestId.slice(-6) + ']' : ''}`

  switch (parseInt(res.data.code)) {

    case 401:
      // if ($app.$store.state.user.token.length != 0) {

      // }
      $app.$store.commit('user/setToken', '');
      $app.$store.commit('user/setUserInfo', {})
      $app.$store.commit('user/clearNoReadMsgCountTimer')
      $app.$store.commit('user/clearbalanceTimer')
      // $app.$store.commit('message/setShowHomePop',false)
      $app.$store.commit('user/setShowReadMsg', false)
      $app.$store.commit('user/setNoReadMsgCount', 0)
      $app._router.push({
        path: '/login',
      })
      return Promise.resolve(res.data)

    case 40002:
      if (res.data.msg != '不弹提示框') {
        $app.$toast(getMsg())

      }
      return Promise.resolve(res.data)

    case 12200:
      if (token) {

      }
      return Promise.resolve(res.data)

    default:
      if (
        res.config.url == 'https://ccdcapi.alipay.com/validateAndCacheCardInfo.json?' ||
        res.config.url == '/melody/api/v1/sysdomain/query'
      ) {
        return Promise.resolve(res.data);
      }
      if (!res.config.self) {
        $app.$toast(getMsg() || "服务器开小差了");
      }
      return Promise.resolve(res.data);

  }


}, (error) => {
  $app.$toast("服务器开小差了");
  return Promise.resolve({
    code: "ERROR", msg: "请检查网络连接!", data: {
      msg: "请检查网络连接",
      code: "ERROR"
    }
  })
})


export const get = (params, url, self = false) => {
  return instance.get(url, { params })
}
export const post = (params, url, self = false) => {
  return instance.post(url, params, { self })
}
